import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import List from '@/components/Icons/List';
import ArrowLineUp from '@/components/Icons/ArrowLineUp';
import Buttons from '@/components/Buttons';
import { useIsMobile } from '@/hooks';
import { SIZES } from '@/styles/media';

import trackEvents from '@/helpers/trackEvents';
import s from './SectionNavigation.module.scss';
import SectionProgressIcon from './SectionProgressIcon';

type SectionNavigationProps = {
  sections: Array<{
    id: string;
    label: string;
    progress: number | null;
    isLoading: boolean;
    hasError?: boolean;
  }>;
  currentSection: string;
  onSelectSection: (sectionId: string) => void;
  completed?: boolean;
  collapsed?: boolean;
  addStickyInset?: boolean;
};

const SectionNavigation: React.FC<SectionNavigationProps> = ({ sections, currentSection, onSelectSection, completed, collapsed, addStickyInset }) => {
  trackEvents.track('Rendered SectionNavigation');
  const isLessThanMd = useIsMobile(SIZES.md);
  const isMobile = (!isLessThanMd && collapsed) || isLessThanMd;
  const [open, setOpen] = useState(true);
  const currentSectionData = sections.find(section => section.id === currentSection);
  useEffect(() => {
    setOpen(!isMobile);
  }, [isMobile]);
  return (
    <nav className={classNames(s.nav, isMobile && open && s.navOpen)}
      {...isMobile
        && {
          style: {
            boxShadow: 'var(--shadow-lg)',
            maxWidth: '100%',
            top: 0,
            width: '100%',
            zIndex: 10,
          },
        }
        || addStickyInset && { style: { maxHeight: 'calc(min(100vh, 100dvh) - 56px)', top: 56 } }
        || {}}
    >
      <Buttons disabled={!isMobile} isWrapper onClick={() => setOpen(!open)} className={classNames(s.header, isMobile ? 'caption' : 'body-sm')}>
        {!isMobile && 'Sections'}
        {isMobile && currentSectionData && (
          <>
            {open
              ? <><ArrowLineUp size={16} />Hide Sections</>
              : <><List size={16} />
                <SectionProgressIcon
                  isLoading={currentSectionData.isLoading}
                  progress={currentSectionData.progress}
                  hasError={false}
                />
                <b>{currentSectionData.label}</b></>}
          </>
        )}
      </Buttons>
      {open && (
        <ul>
          {sections.map(section => (
            <li key={section.id}>
              <Buttons
                isWrapper
                className={`${section.id === currentSection ? s.active : ''} ${section.hasError ? s.error : ''}`}
                onClick={() => {
                  onSelectSection(section.id);
                  if (isMobile) {
                    setOpen(false);
                  }
                }}
              >
                {section.label}
                {!completed && (
                  <SectionProgressIcon
                    isLoading={section.isLoading}
                    progress={section.progress}
                    hasError={!!section.hasError}
                  />
                )}
              </Buttons>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
};

export default SectionNavigation;
